module.exports = __webpack_public_path__ + "media/svg/centang-ae2994ab.svg";